"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistRequestHandler = void 0;
const timer_1 = __importDefault(require("../../logger/timer"));
const getRequestConfigWithToken_1 = require("../../requestHandler/getRequestConfigWithToken");
const BaseRequestHandler_1 = require("../../requestHandler/BaseRequestHandler");
const CartRequestHandler_1 = require("../../cart/requestHandlers/CartRequestHandler");
class WishlistRequestHandler {
    /**
     * GET wishlist if present
     * @param shopId
     * @param currencyCode
     * @param visitorId
     */
    static getWishlist(shopId, currencyCode, visitorId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.params = {
                currencyCode
            };
            return BaseRequestHandler_1.BaseRequestHandler.performRequestWithPossibleError("GET", `/shop/${shopId}/visitors/${visitorId}/wishlist`, configuration).then((response) => {
                var _a;
                if (CartRequestHandler_1.isError(response)) {
                    if (((_a = response.originalError.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                        return null;
                    }
                    throw response;
                }
                return response;
            });
        });
    }
    /**
     * Add item to (potentially new) wishlist by POST
     * @param shopId
     * @param currencyCode
     * @param visitorId
     * @param itemId
     */
    static postWishlistItem(shopId, currencyCode, visitorId, itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = { itemId };
            configuration.params = { currencyCode };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("POST", `/shop/${shopId}/visitors/${visitorId}/wishlist`, configuration);
        });
    }
    /**
     * DELETE item from known wishlist
     * @param shopId
     * @param currencyCode
     * @param visitorId
     * @param listId
     * @param itemId
     */
    static deleteWishlistItem(shopId, currencyCode, visitorId, listId, itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.params = { currencyCode };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("DELETE", `/shop/${shopId}/visitors/${visitorId}/wishlist/${listId}/item/${itemId}`, configuration);
        });
    }
}
__decorate([
    timer_1.default("API", "Customer")
], WishlistRequestHandler, "getWishlist", null);
__decorate([
    timer_1.default("API", "Customer")
], WishlistRequestHandler, "postWishlistItem", null);
__decorate([
    timer_1.default("API", "Customer")
], WishlistRequestHandler, "deleteWishlistItem", null);
exports.WishlistRequestHandler = WishlistRequestHandler;
